// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"_2b4XeUoF8c3moviVcRWFsy"};